import React, { useEffect, useState } from 'react';
import { Github, Linkedin, Mail, Trophy } from 'lucide-react';
import duckImage from '../images/duck.gif';

const HeroSection = () => {
  const [typedText, setTypedText] = useState('');
  const [showCursor, setShowCursor] = useState(true);
  const fullText = "CS Student & Developer";

  useEffect(() => {
    let index = 0;
    const typingInterval = setInterval(() => {
      if (index <= fullText.length) {
        setTypedText(fullText.slice(0, index));
        index++;
      } else {
        clearInterval(typingInterval);
      }
    }, 100);

    const cursorInterval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 500);

    return () => {
      clearInterval(typingInterval);
      clearInterval(cursorInterval);
    };
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-cute-dark" />

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto pt-20">
        {/* Duck Avatar */}
        <div className="mb-8 flex justify-center">
          <div className="relative group">
            <div className="relative w-28 h-28 md:w-36 md:h-36">
              <img
                src={duckImage}
                alt="Esther's Avatar"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Greeting */}
        <p className="text-white/40 text-base md:text-lg font-medium mb-2 opacity-0 animate-slide-up" style={{ animationDelay: '0.1s', animationFillMode: 'forwards' }}>
          Hi hi hello, I'm
        </p>

        {/* Name */}
        <h1 className="text-6xl md:text-8xl font-display mb-4 text-white opacity-0 animate-slide-up tracking-wider" style={{ animationDelay: '0.2s', animationFillMode: 'forwards' }}>
          Esther
        </h1>

        {/* Typing Effect */}
        <div className="h-8 md:h-10 mb-6 opacity-0 animate-slide-up" style={{ animationDelay: '0.3s', animationFillMode: 'forwards' }}>
          <p className="text-base md:text-lg text-white/50 font-mono">
            {typedText}
            <span className={`inline-block w-0.5 h-5 bg-white/60 ml-1 ${showCursor ? 'opacity-100' : 'opacity-0'}`} />
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center opacity-0 animate-slide-up" style={{ animationDelay: '0.5s', animationFillMode: 'forwards' }}>
          <button
            onClick={() => scrollToSection('projects')}
            className="px-6 py-3 rounded-full font-medium bg-white text-black hover:bg-white/90 transition-all duration-300 hover:scale-105"
          >
            Projects
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="px-6 py-3 rounded-full font-medium border border-white/20 text-white/80 hover:bg-white/5 hover:border-white/30 transition-all duration-300"
          >
            Contact me
          </button>
        </div>

        {/* Social Links */}
        <div className="mt-10 flex justify-center gap-4 opacity-0 animate-slide-up" style={{ animationDelay: '0.6s', animationFillMode: 'forwards' }}>
          <a
            href="https://github.com/ashtherz"
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 transition-all duration-300"
          >
            <Github className="w-5 h-5 text-white/60 hover:text-white" />
          </a>
          <a
            href="https://www.linkedin.com/in/esther-d-5629a91aa/"
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 transition-all duration-300"
          >
            <Linkedin className="w-5 h-5 text-white/60 hover:text-white" />
          </a>
          <a
            href="https://devpost.com/ashtherz"
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 transition-all duration-300"
          >
            <Trophy className="w-5 h-5 text-white/60 hover:text-white" />
          </a>
          <a
            href="mailto:estherdjaidiguna@gmail.com"
            className="p-3 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 transition-all duration-300"
          >
            <Mail className="w-5 h-5 text-white/60 hover:text-white" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
